<div class="container-fluid">
  <a class="brand-logo" href="/">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="48" />
    <!--h2 class="brand-text text-primary ml-1">Vuexy</h2-->
  </a>
  <div class="row justify-content-center align-items-center min-vh-100 bg-light">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="card shadow-sm">
        <div class="card-body p-4 p-md-5">
          <h2 class="text-center mb-3">Request Exams</h2>

          <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
            <!-- Zeraki Email (Only for RM) -->
            <div class="form-group mb-1" *ngIf="isRM">
              <label for="managerEmail" class="form-label">Zeraki Email Address *</label>
              <input type="email" id="managerEmail" class="form-control" formControlName="managerEmail"
                [class.is-invalid]="requestForm?.get('managerEmail')?.invalid && requestForm?.get('managerEmail')?.touched"
                placeholder="Enter your &#64;zeraki.app email address">
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('managerEmail')?.invalid && requestForm?.get('managerEmail')?.touched">
                <span *ngIf="requestForm?.get('managerEmail')?.errors?.['required']">
                  Email address is required
                </span>
                <span *ngIf="requestForm?.get('managerEmail')?.errors?.['email']">
                  Please enter a valid email address
                </span>
                <span *ngIf="requestForm?.get('managerEmail')?.errors?.['zerakiEmail']">
                  Email must be a &#64;zeraki.app address
                </span>
              </div>
            </div>
            <!-- County Selection (Only for RM) -->
            <div class="form-group mb-1" *ngIf="isRM">
              <label for="countyId" class="form-label">Select County *</label>
              <select id="countyId" class="form-control" formControlName="countyId" (change)="onCountyChange()"
                [class.is-invalid]="requestForm?.get('countyId')?.invalid && requestForm?.get('countyId')?.touched">
                <option value="" disabled selected>Choose County</option>
                <option *ngFor="let county of counties" [value]="county.code">{{ county.name }}</option>
              </select>
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('countyId')?.invalid && requestForm?.get('countyId')?.touched">
                Please select a county
              </div>
            </div>

            <!-- School Selection (Only for RM) -->
            <div class="form-group mb-1 position-relative" *ngIf="isRM">
              <label for="school" class="form-label">Select School *</label>
              <input id="school" class="form-control" type="text"
                [formControl]="schoolSearchControl"
                [class.is-invalid]="requestForm?.get('schoolId')?.invalid && requestForm?.get('schoolId')?.touched"
                [disabled]="!requestForm?.get('countyId')?.value || loadingSchools"
                placeholder="Type to search your school"
                (focus)="showSchoolDropdown = true"
                (input)="onSchoolInput()"
                (blur)="onSchoolBlur()" />
              <div *ngIf="loadingSchools" class="text-info mt-1">Loading schools...</div>
              <ul *ngIf="showSchoolDropdown && filteredSchools.length > 0 && !loadingSchools" 
                  class="list-group position-absolute w-100 zindex-dropdown" 
                  style="max-height: 200px; overflow-y: auto;">
                <li *ngFor="let school of filteredSchools"
                    class="list-group-item list-group-item-action cursor-pointer"
                    (mousedown)="selectSchool(school)">{{ school.schoolName }}</li>
              </ul>
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('schoolId')?.invalid && requestForm?.get('schoolId')?.touched">
                Please select a school
              </div>
            </div>

            <!-- School Name (Only for non-RM) -->
            <div class="form-group mb-1" *ngIf="!isRM">
              <label for="schoolName" class="form-label">School Name *</label>
              <input type="text" id="schoolName" class="form-control" formControlName="schoolName"
                [class.is-invalid]="requestForm.get('schoolName').invalid && requestForm.get('schoolName').touched">
              <div class="invalid-feedback"
                *ngIf="requestForm.get('schoolName').invalid && requestForm.get('schoolName').touched">
                School name is required
              </div>
            </div>

            <!-- Your Name -->
            <div class="form-group mb-1">
              <label for="fullName" class="form-label">{{ isRM ? 'School Representative Name' : 'Your Name' }} *</label>
              <input type="text" id="fullName" class="form-control" formControlName="fullName"
                [class.is-invalid]="requestForm?.get('fullName')?.invalid && requestForm?.get('fullName')?.touched">
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('fullName')?.invalid && requestForm?.get('fullName')?.touched">
                {{ isRM ? 'School representative name' : 'Your name' }} is required
              </div>
            </div>

            <!-- Email -->
            <div class="form-group mb-1">
              <label for="email" class="form-label">{{ isRM ? 'School Representative Email Address' : 'Email Address' }} *</label>
              <input type="email" id="email" class="form-control" formControlName="email"
                [class.is-invalid]="requestForm?.get('email')?.invalid && requestForm?.get('email')?.touched">
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('email')?.invalid && requestForm?.get('email')?.touched">
                {{ isRM ? 'School representative email address' : 'Email address' }} is required
              </div>
            </div>

            <!-- Phone Number -->
            <div class="form-group mb-1">
              <label for="phoneNumber" class="form-label">{{ isRM ? 'School Representative Phone Number' : 'Phone Number' }} *</label>
              <input type="tel" id="phoneNumber" class="form-control" formControlName="phoneNumber"
                placeholder="e.g., 0712345678"
                [class.is-invalid]="requestForm?.get('phoneNumber')?.invalid && requestForm?.get('phoneNumber')?.touched">
              <div class="invalid-feedback"
                *ngIf="requestForm?.get('phoneNumber')?.invalid && requestForm?.get('phoneNumber')?.touched">
                {{ isRM ? 'School representative phone number' : 'Phone number' }} is required
              </div>
            </div>

            <!-- Form Selection -->
            <div class="form-group mb-1">
              <label class="form-label">Select Exam Packages*</label>
              <div class="row g-3">
                <div class="col-6 col-md-3" *ngFor="let plan of formOptions">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" [id]="'plan' + plan.planId"
                      [checked]="isFormSelected(plan.planId)" (change)="onFormSelect($event, plan.planId)">
                    <label class="form-check-label" [for]="'plan' + plan.planId" *ngIf="!isFree">
                      {{plan.planName}} - KES {{plan.hasDiscount ? plan.discountedAmount : plan.amount}}
                      <span class="text-success small" *ngIf="plan.hasDiscount">
                        <br>Discounted from KES {{plan.amount}}
                      </span>
                    </label>
                    <label class="form-check-label" [for]="'plan' + plan.planId" *ngIf="isFree">
                      {{plan.planName}}
                    </label>
                  </div>
                </div>
              </div>
              <div class="text-danger small"
                *ngIf="requestForm.get('planIds').invalid && requestForm.get('planIds').touched">
                Please select at least one form
              </div>
            </div>

            <!-- Total Price -->
            <div class="form-group mb-1" *ngIf="requestForm?.get('planIds')?.value?.length > 0 && !isFree">
              <label for="totalPrice" class="form-label">Total Price</label>
              <input type="text" id="totalPrice" class="form-control" 
                [value]="'KES ' + getTotalPrice()"
                readonly
                style="background-color: #f8f9fa; color: #6c757d; cursor: not-allowed;">
            </div>

            <!-- Referral Code -->
            <div class="form-group mb-1">
              <label for="referralCode" class="form-label">Referral Code (Optional)</label>
              <input type="text" id="referralCode" class="form-control" formControlName="referralCode">
            </div>

            <!-- Submit Button -->
            <div class="text-center mt-4">
              <button type="submit" class="btn btn-primary btn-lg px-5" [disabled]="isSubmitting">
                <span *ngIf="!isSubmitting">Submit Request</span>
                <span *ngIf="isSubmitting" class="d-flex align-items-center justify-content-center">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Submitting...
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>